<template>
  <div>

    <c-title>Projekt bearbeiten</c-title>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <c-project-form
      v-else
      :data="data"
      @submit="submit"
      @validation="validationStatus = $event"
    />

  </div>
</template>

<script>
import CBusy from '@/components/CBusy'
import CProjectForm from '@/components/project/CProjectForm'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'VProjectEdit',

  components: {
    CBusy,
    CProjectForm,
    CTitle
  },

  props: {
    identifier: {
      type: String
    }
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      validationStatus: this.$config.status.IDLE,
      data: null
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('projects/project/', {
      params: { identifier: this.identifier }
    })
      .then(response => {
        this.data = response.data.project
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(error => {
        handleRequestError({
          error,
          fallback: 'Ihr Projekt kann zurzeit leider nicht geladen werden. Bitte versuchen Sie es später erneut.'
        })
        this.$router.push({ name: 'dashboard' })
      })
  },

  methods: {
    submit (data) {
      if (this.validationStatus !== this.$config.status.SUCCESS) {
        return
      }

      this.$api.patch(`projects/project/${this.identifier}/`, data)
        .then(response => {
          this.$store.commit('notifications/add', {
            text: 'Ihr Projekt wurde aktualisiert.',
            type: 'success'
          })
          this.$router.push({ name: 'dashboard' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Ihr Projekt kann zurzeit leider nicht gespeichert werden. Bitte versuchen Sie es später erneut.'
          })
        })
    }
  }
}
</script>
